//系统列表
export const platformType = [
    {label: 'UCENTER', value: 'UCENTER'},
    {label: 'ASSP', value: 'ASSP'},
    {label: 'MTDS', value: 'MTDS'},
    {label: 'WSP', value: 'WSP'},
]

//组织类型
export const orgType = [
    {label: '欧派', value: 'OPPEIN'},
    {label: '代理商', value: 'AGENT'},
    {label: '第三方', value: 'OTHER'},
]

//角色来源类型
export const roleType = [
    {label: '职位', value: 'POSITION'},
    // {label:'部门',value:'DEPARTMENT'},
].concat(platformType)


//系统日志类型
export const systemLogType = [
    {label: '登录', value: 'LOGIN'},
    {label: '查看', value: 'VIEW'},
    {label: '修改', value: 'UPDATE'},
    {label: '新增', value: 'ADD'},
    {label: '删除', value: 'DEL'},
    {label: '其他', value: 'OTHER'},
    // {label:'无效请求',value:''},
]

//品牌
export const brand = [
    {value: 'brand_oppein', label: "欧派"},
    {value: 'brand_oboli', label: "欧铂丽"},
    {value: 'brand_oboni', label: "欧铂尼"},
    // {value:'OP',label:"欧派"},
    // {value:'OB',label:"欧铂丽"},
];
//品类
export const category = [
    {value: 'category_chugui', label: "橱柜"},
    {value: 'category_weiyu', label: "卫浴"},
    {value: 'category_yigui', label: "集成家居"},
    {value: 'category_mumen', label: "木门"},
    {value: 'category_qiangshi', label: "软装"},
    {value: 'category_bigFamily', label: "大家居"},
    {value: 'category_dajiaju', label: "大家居"},
    {value: 'category_jinshumenchuang', label: "金属门窗"},

    {value: 'CUPBOARD', label: "橱柜"},
    {value: 'BATHROOM', label: "卫浴"},
    {value: 'ARMOIRE', label: "集成家居"}, //衣柜
    {value: 'DOOR', label: "木门"},
    // {value:'category_qiangshi',label:"软装"},
    // {value:'category_bigFamily',label:"大家居"},

]
//品牌品类
export const brandCategory = [
    {value: 'brand_oppein-category_chugui', label: "欧派-橱柜"},
    {value: 'brand_oppein-category_weiyu', label: "欧派-卫浴"},
    {value: 'brand_oppein-category_yigui', label: "欧派-集成家居"},
    {value: 'brand_oppein-category_qiangshi', label: "欧派-软装"},
    {value: 'brand_oboli-category_chugui', label: "欧铂丽-橱柜"},
    {value: 'brand_oboli-category_yigui', label: "欧铂丽-集成家居"},
    {value: 'brand_oboni-category_jinshumenchuang', label: "欧铂尼-金属门窗"},
    {value: 'brand_oboni-category_mumen', label: "欧铂尼-木门"},

]
//部门类型
export const departType = [
    {value: '1', label: "欧派公司"},
    {value: '2', label: "商场"},
    {value: '3', label: "门店"},
    {value: '4', label: "部门"},
]
//表达式
export const expression = [
    {value: '=', label: "="},
    {value: '=<', label: "=<"},
    {value: 'like', label: "like"},
    {value: 'in', label: "in"},
    {value: 'all', label: "all"},
]
//表达式标记
export const depatTag = [
    {value: 'and', label: "and"},
    {value: 'or', label: "or"},
]
//维度名称
export const vdoingName = [
    {value: 'region_id', label: "区域"},
    {value: 'department_id', label: "部门"},
    {value: 'position_id', label: "职位"},
]
//性别
export const sexStr = [
    {value: "MALE", label: "男"},
    {value: "FEMALE", label: "女"},
];
//账号列表下拉数据
export const accountTypeList = [
    {value: "ASSP", label: "ASSP"},
    {value: "MTDS", label: "MTDS"},
    {value: "WSP", label: "WSP"},
];

export const rootMarketClassifyDict = [
    {"label": "融合营销线", "value": "OP-DJG-RH1"},
    {"label": "欧派衣柜营销线", "value": "OP-YG0"},
    {"label": "欧派橱柜营销线", "value": "OP-CG0"},
    {"label": "整装大家居营销线", "value": "OP-DJG1"},
    {"label": "欧派软装营销线", "value": "OP-RZ0"},
    {"label": "欧派卫浴营销线", "value": "OP-WY0"},
    {"label": "欧派工程营销线", "value": "OP-GC0"},
    {"label": "欧派木门营销线", "value": "OP-MM0"},
    {"label": "欧铂丽营销线", "value": "OB-OBL1"},
    {"label": "欧派金属门窗营销线", "value": "OP-JSMC0"},
    {"label": "广州分公司营销线", "value": "OP-GF1"}
];
